// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1KQmA","calendarButtons":"ClockData_calendarButtons__3MAri"};